var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 8H4.0606C3.89324 8 3.75757 8.13567 3.75757 8.30303C3.75757 8.47039 3.89324 8.60606 4.0606 8.60606H4.66666C4.83402 8.60606 4.96969 8.47039 4.96969 8.30303C4.96969 8.13567 4.83402 8 4.66666 8Z",
    stroke: "#4D5971",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30289 8H7.69683C7.52947 8 7.3938 8.13567 7.3938 8.30303C7.3938 8.47039 7.52947 8.60606 7.69683 8.60606H8.30289C8.47025 8.60606 8.60592 8.47039 8.60592 8.30303C8.60592 8.13567 8.47025 8 8.30289 8Z",
    stroke: "#4D5971",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 11.0303H4.0606C3.89324 11.0303 3.75757 11.1659 3.75757 11.3333C3.75757 11.5007 3.89324 11.6363 4.0606 11.6363H4.66666C4.83402 11.6363 4.96969 11.5007 4.96969 11.3333C4.96969 11.1659 4.83402 11.0303 4.66666 11.0303Z",
    stroke: "#4D5971",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30289 11.0303H7.69683C7.52947 11.0303 7.3938 11.1659 7.3938 11.3333C7.3938 11.5007 7.52947 11.6363 7.69683 11.6363H8.30289C8.47025 11.6363 8.60592 11.5007 8.60592 11.3333C8.60592 11.1659 8.47025 11.0303 8.30289 11.0303Z",
    stroke: "#4D5971",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9394 8H11.3333C11.1659 8 11.0303 8.13567 11.0303 8.30303C11.0303 8.47039 11.1659 8.60606 11.3333 8.60606H11.9394C12.1067 8.60606 12.2424 8.47039 12.2424 8.30303C12.2424 8.13567 12.1067 8 11.9394 8Z",
    stroke: "#4D5971",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4545 2.54541H2.54537C1.87594 2.54541 1.33325 3.0881 1.33325 3.75753V12.8484C1.33325 13.5179 1.87594 14.0606 2.54537 14.0606H13.4545C14.1239 14.0606 14.6666 13.5179 14.6666 12.8484V3.75753C14.6666 3.0881 14.1239 2.54541 13.4545 2.54541Z",
    stroke: "#4D5971",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36353 1.93945V3.75764",
    stroke: "#4D5971",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6362 1.93945V3.75764",
    stroke: "#4D5971",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 5.57593H14.6666",
    stroke: "#4D5971",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ffac6d2edbc945d975a79a8326c859c8.svg";
export { ForwardRef as ReactComponent };